import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "map",
  class: "w-full h-[800px]"
}

import axios from 'axios';
import { onMounted } from "vue";
import L from "leaflet";



import "leaflet/dist/leaflet.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'arenaMap',
  setup(__props) {

const normandy = {
    fullName: 'Normandy',
    name: 'normandy',
    hash: '#normandy',
    selectIndex: 7,
    scale: 2.48099,
    latMin: -139.87,
    latMax: 0,
    latGridMax: 34.6957,
    lngMin: 0,
    lngMax: 125.51,
    lngGridMax: 31.1337,
    gridHopZoom: 6,
    defaultZoom: 3,
    minZoom: 3,
    maxZoom: 5,
    tileUrl: `./${process.env.BASE_URL}/map/normandy/{z}/{x}/{y}.png`
};

const mapCenter = () => {
    return [(Math.abs(normandy.latMax) - Math.abs(normandy.latMin)) / 2 + 20, (Math.abs(normandy.lngMax) - Math.abs(normandy.lngMin)) / 2 + 2];
} 

const maxBounds = () => {
    return [
        [normandy.latMin, normandy.lngMin],
        [normandy.latMax, normandy.lngMax]
    ];
};
        
const tileBounds = () => {
    return [
        [normandy.latMin, normandy.lngMin],
        [normandy.latMax, normandy.lngMax]
    ];
}

onMounted(() => {
    const map = L.map('map', {
        crs: L.CRS.Simple,
        attributionControl: false,
        zoomDelta: 0.1,
        zoomSnap: 0        
        // options
    }).setView(mapCenter() as any, 3);
    L.tileLayer(normandy.tileUrl, {
        maxZoom: normandy.maxZoom,
        minZoom: normandy.minZoom,
        bounds: tileBounds() as any,
    }).addTo(map);

    map.setMaxBounds(maxBounds() as any)
    


    
    axios.get('https://clashofeaglesdata.blob.core.windows.net/stats/fields.json').then(response => {
        response.data.map(field => {
            let pos = LatLng(field.Position.X, field.Position.Z) as any;

            if (field.Country == 102) {
                L.marker(pos, { icon: iconAllied, title: field.Name }).addTo(map);
            } else {
                L.marker(pos, { icon: iconAxis, title: field.Name }).addTo(map);
            }

        });
    })
})

var LatLng = (x : number, y : number) => {
    let lat = x - 146643;
    lat = lat / 63763.30751;
    lat = lat - 3.5;
    
    let lng = y - 250937;
    lng = lng / 112533.651;
    lng = lng + 1.925;

    return [lat * 26, lng * 46.2];
}

var iconAllied = L.icon({
    iconUrl: `./${process.env.BASE_URL}/map/marker/allied.png`,
    iconSize: [40, 40]
});

var iconAxis = L.icon({
    iconUrl: `./${process.env.BASE_URL}/map/marker/axis.png`,
    iconSize: [40, 40]
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})